import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App.tsx";
import "./styles/app.css";

// Tokens are dark by default with a [data-theme="light"] override, matching
// eScorer. Follow the device rather than adding a switch nobody asked for.
const light = window.matchMedia("(prefers-color-scheme: light)");
const applyTheme = () => document.documentElement.setAttribute("data-theme", light.matches ? "light" : "dark");
applyTheme();
light.addEventListener("change", applyTheme);

// Installable on a phone's home screen. Production only: Vite's dev server
// doesn't serve the worker, and a stale one would cache dev modules.
if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => void navigator.serviceWorker.register("/sw.js"));
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
